<template>
  <div>
    <div class="ch-agr-box">
      <div class="ch-agr-content-box">
        <div class="ch-agr-content">
          <div class="ch-complete-box">
            <div class="ch-complete-icon">
              <i class="el-icon-check"></i>
            </div>
            <div class="ch-complete-content">
              <div class="ch-complete-label">恭喜你，注册成功！</div>
              <div class="ch-complete-desc">
                5秒后自动登录系统
                <el-button type="text" class="ch-complete-desc" @click="onLogin">立即登录</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  created(){
    this.goLogin()
    },
  methods: {
    goLogin(){
      console.log("???");
      let that=this;
      setTimeout(function () {
        that.$router.replace({path:"/login"})
      },2000)

    },
      onLogin(){
        this.$router.replace('/login')
      }
  },
};
</script>


<style lang="less" scoped>
.ch-agr-box {
  margin-top: 35px;
  padding: 35px 30px;
  border: 1px solid #efefef;
  > .ch-agr-title {
    font-size: 24px;
    color: #666666;
    font-weight: 400;
    text-align: center;
  }
  > .ch-agr-content-box {
    margin-top: 35px;
    padding: 31px 0;

    > .ch-agr-content {
      font-size: 14px;
      color: #666666;
      line-height: 24px;
      padding: 0 31px;
      height: 588px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    > .ch-agr-content::-webkit-scrollbar-thumb {
      background-color: #efefef;
    }
  }

  .ch-complete-box {
    padding: 50px 50px;
    background: #f9f9f9;
    border: 1px solid #efefef;
    display: flex;
    > .ch-complete-icon {
      height: 54px;
      width: 54px;
      background: linear-gradient(0deg, #86b4fb, #3984f7);
      border: 1px solid #efefef;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      .el-icon-check{
      color: #ffffff;
      font-size: 40px;
      font-weight: bold;
      }
    }
    > .ch-complete-content {
      flex: 1;
      margin-left: 20px;
      text-align: center;
      > .ch-complete-label {
        font-size: 26px;
        font-weight: 400;
        color: #fd9a25;
        line-height: 42px;
        white-space: nowrap;
      }
      > .ch-complete-desc {
        font-size: 12px;
        font-weight: 300;
        color: #333333;
        line-height: 42px;
      }
    }
  }
}
</style>